<script>
import DetailsReview from "@/components/reviews/page/DetailsReview.vue";
import {api} from "@/modules/api";
import BreadcrumpsProfil from "@/components/BreadcrumpsProfil.vue";

export default {
  name: 'ListReviews',
  components: { BreadcrumpsProfil, DetailsReview },
  data () {
    return {
      reviews: {}
    }
  },
  mounted () {
    this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  methods: {
    loadData () {
      api.reviews.getUserReviews().then((res) => {
        this.reviews = res
      })
    }
  }
}
</script>

<template>
  <section class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <breadcrumps-profil :second-items="{ text: 'Mes avis' }" />
      <div class="gap-4 sm:flex sm:items-center sm:justify-between">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">Mes avis ({{ reviews.length }})</h2>
      </div>
      <div class="mt-6 flow-root sm:mt-8">
        <div class="divide-y divide-gray-200 dark:divide-gray-700">
          <details-review v-for="(review, index) in reviews" :key="index" :review="review" />
        </div>
      </div>
    </div>
  </section>
</template>
